import { isLive, isPublished } from '@iws/theme-schema/blog'

import { Badge } from '@/components/ui/badge'

/** Published, Scheduled (published with a future publish time) or Draft. */
export const BlogStatusBadge = ({ status, publishedAt }: { status: string; publishedAt?: string | null }) => {
  if (!isPublished({ status })) return <Badge tone="warning">Draft</Badge>
  return isLive({ status, published_at: publishedAt }) ? <Badge tone="success">Published</Badge> : <Badge tone="info">Scheduled</Badge>
}
